import { useEffect, useState } from "react";
import { ThemeContext } from "./ThemeContext";
import { Theme } from "./theme.enums";
import { MileageTheme } from "./MileageTheme";

export interface ThemeProviderProps {
  children: React.ReactNode;
}

const StorageKeys = {
  THEME: "theme",
  OPACITY: "opacity",
};

const GetThemeFromMemory = () => {
  const theme = localStorage.getItem(StorageKeys.THEME);
  if (!theme) return Theme.DARK;
  return theme === Theme.LIGHT ? Theme.LIGHT : Theme.DARK;
};

const GetOpacityFromMemory = () => {
  const opacity = localStorage.getItem(StorageKeys.OPACITY);
  if (!opacity) return 0.72;
  const parsed = parseFloat(opacity);
  return isNaN(parsed) ? 0.72 : parsed;
};

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const [theme, setTheme] = useState<Theme>(GetThemeFromMemory());
  const [opacity, setOpacity] = useState<number>(GetOpacityFromMemory());

  useEffect(() => {
    localStorage.setItem(StorageKeys.OPACITY, opacity.toString());
  }, [opacity]);

  useEffect(() => {
    localStorage.setItem(StorageKeys.THEME, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) =>
      prevTheme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT,
    );
  };

  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", theme);
  }, [theme]);

  const mileageTheme = {
    darkRed: "rgba(179, 0, 0, 1)",
    mediumRed: "rgba(215, 48, 31, 1)",
    lightRed: "rgba(239, 101, 72, 1)",
    darkOrange: "rgba(252, 141, 89, 1)",
    mediumOrange: "rgba(253, 187, 132, 1)",
    lightOrange: "rgba(254, 240, 217, 1)",
    yellow: "rgba(237, 248, 177, 1)",
    green1: "rgba(199, 233, 180, 1)",
    green2: "rgba(127, 205, 187, 1)",
    green3: "rgba(65, 171, 93, 1)",
    green4: "rgba(35, 139, 69, 1)",
    green5: "rgba(0, 109, 44, 1)",
    green6: "rgba(0, 68, 27, 1)",
  } as MileageTheme;

  return (
    <ThemeContext.Provider
      value={{ theme, toggleTheme, mileageTheme, opacity, setOpacity }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
